export var LOGIN_FLOWS = {
    PEAKS_UPAG_FLOW: "guestpay",
    PEAKS_PAYLATER_FLOW: "paylater",
    PEAKS_SECURED_INSTALLMENTS_FLOW: "securedinstallments",
    // Later expand this with vista flows.
};
//# sourceMappingURL=loginFlows.js.map